import { z } from "zod"

export const IssueSchema = z.object({
  requirementId: z.string(),
  explanation: z.string(),
})

export type Issue = z.infer<typeof IssueSchema>
